import React , {useReducer} from "react";
import Context from './context';



const initialState = { tripType: null, user:{} , linkType :'',  stepOneData:{}, secondLevelData:{}, agent : {} , 
    privateOrbits: [], sadirOrbits: [], isLoadedSadirOrbits: false, selectedOrbit: '', side: 'מאומן', startLocation: '',
    startLocations: null, stops: null, tripStops: [], saturdayStops: [], sleepStops: [],
    date: '', hour: '', name: '',englishName: '' ,flightNumber:'', flightNumberBack: '' ,  amount: 1, phone: '', carType: '', carTypes: null , carBackType: null, notes: '',
    email: '', dateBack: '', hourBack: '', selectedOrbitSpecificNote: '' , selectedOrbitBackSpecificNote:'' ,  selectedOrbitBack: '', priceBack: 0 , approveCondition: false  , isDialogOpen : false, id:'' ,price: 0 , currency : ' ', pricePercent: 0 , priceBackPercent:0,  countryCode : '' , secondCountryCode : '' ,
    maxPayments : 1 , minPayments : 1 , customerSettings: null , terms : null , range2025 : null , recommendedHours : null , isTrain : false , trainsOrbits : null , trainsTerms : ''
};

const reducer = (state, action) => {

    switch (action.type) {
        case "SET_TRIP_TYPE" :
            return {...state, tripType: action.payload};
        case "TRAINS_TERMS" :
            return {...state, trainsTerms: action.payload};
        case "SET_TRAINS_ORBITS" :
            return {...state, trainsOrbits: action.payload};
        case "SET_IS_TRAIN" :
            return {...state, isTrain: action.payload};
        case "SET_USER" :
            return {...state, user: action.payload};
        case "SET_LINK_TYPE" :
            return {...state, linkType: action.payload};
        case "SET_STEP_ONE_DATA" :
            return {...state, stepOneData: action.payload};
        case "SET_SECOND_LEVEL_DATA" :
            return {...state, secondLevelData: action.payload};
        case "SET_AGENT" :
                return {...state, agent: action.payload};
        case "TERMS" :
            return {...state, terms: action.payload};
        case "SET_PRIVATE_ORBITS" :
            return {...state, privateOrbits: action.payload};
        case "SET_SADIR_ORBITS" :
            return {...state, sadirOrbits: action.payload, isLoadedSadirOrbits: true};
        case "SET_SELECTED_ORBIT" :
            return {...state, selectedOrbit: action.payload};
        case "SET_SELECTED_ORBIT_BACK" :
            return {...state, selectedOrbitBack: action.payload};
        case "SET_SIDE" :
            return {...state, side: action.payload};
        case "SET_START_LOCATIONS" :
            return {...state, startLocations: action.payload};
        case "SET_START_LOCATION" :
            return {...state, startLocation: action.payload};
        case "SET_GOOD_URL" :
            return {...state, goodUrl: "true"};
            case "SET_STOPS" :
                return {...state, stops: action.payload};    
        case "SET_TRIP_STOPS" :
            return {...state, tripStops: action.payload};
        case "SET_SATURDAY_STOPS" :
            return {...state, SaturdayStops: action.payload};
        case "SET_SLEEP_STOPS" :
            return {...state, sleepStops: action.payload};
        case "SET_RANGE_2025" :
            return {...state, range2025: action.payload};
        case "SET_RECOMMENDED_HOURS" :
            return {...state, recommendedHours: action.payload};
        case "SET_DATE" :
            return {...state, date: action.payload};
        case "SET_HOUR" :
            return {...state, hour: action.payload};
        case "SET_DATE_BACK" :
            return {...state, dateBack: action.payload};
        case "SET_HOUR_BACK" :
            return {...state, hourBack: action.payload};
        case "SET_NAME" :
            return {...state, name: action.payload};
        case "SET_ENGLISH_NAME" :
                return {...state, englishName: action.payload};
        case "SET_FLIGHT_NUMBER" :
                return {...state, flightNumber: action.payload};
        case "SET_FLIGHT_NUMBER_BACK" :
                return {...state, flightNumberBack: action.payload};
        case "SET_AMOUNT" :
            return {...state, amount: action.payload};
        case "SET_PHONE" :
            return {...state, phone: action.payload};
        case "SET_ORBIT_NOTE" :
            return {...state, selectedOrbitSpecificNote: action.payload};
        case "SET_ORBIT_BACK_NOTE" :
                return {...state, selectedOrbitBackSpecificNote: action.payload};    
        case "SET_ANOTHER_PHONE" :
            return {...state, anotherPhone: action.payload};
            case "SET_COUNTRY_CODE" :
                return {...state, countryCode: action.payload};
                case "SET_SECOND_COUNTRY_CODE" :
            return {...state, secondCountryCode: action.payload};
        case "SET_CAR_TYPE" :
            return {...state, carType: action.payload};
        case "SET_CAR_BACK_TYPE" :
            return {...state, carBackType: action.payload};
        case "SET_CAR_TYPES" :
            return {...state, carTypes: action.payload};
        case "CUSTOMER_SETTINGS" :
            return {...state, customerSettings: action.payload};
        case "SET_NOTES" :
            return {...state, notes: action.payload};
        case "SET_EMAIL" :
            return {...state, email: action.payload};
        case "SET_PRICE_BACK" :
            return {...state, priceBack: action.payload};
        case "SET_APROVE_CONDITION" :
            return {...state, approveCondition: action.payload};
        case "SET_IS_DAILOG_OPEN" :
            return {...state, isDialogOpen: action.payload};
        case "SET_ID" :
            return {...state, id: action.payload};
        case "SET_PRICE" :
                return {...state, price: action.payload};
        case "SET_PRICE_PERCENT" :
                return {...state, pricePercent: action.payload};
        case "SET_PRICE_BACK_PERCENT" :
                return {...state, priceBackPercent: action.payload};
        case "SET_CURRENCY" :
               return {...state, currency: action.payload};
        case "SET_MAX_PAYMENTS" :
                return {...state, maxPayments: action.payload};
        case "SET_MIN_PAYMENTS" :
                return {...state, minPayments: action.payload};
        case "RESET" :
            return {...initialState};
        default:
            return state;

    }
};

const ContextProvider = (props) => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const value = {state, dispatch};

    return <Context.Provider value={value}>{props.children}</Context.Provider>;
}

export default ContextProvider;